import React from "react";
import Modal from "react-bootstrap/Modal";

const AuroraBilledCostModal = ({ shipment, show, onHide }) => {
  const src =
    `https://www2.shippersedge.com/shipment/modals/chargeDetails.cfm` +
    `?field=billedCost&wsdl&secid=${shipment?.loadDetails?.secureId}&i=${shipment?.id}`;
  return (
    <Modal show={show} onHide={onHide} dialogClassName="customModalFullSize">
      <Modal.Header closeButton>
        <Modal.Title>Complete Billing Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted small mb-2">
          Your billed amount exceeds the estimate. Please complete the billing
          detail form below.
        </p>
        <iframe
          src={src}
          title="Billing Details"
          style={{ width: "110%", height: "600px", border: "none" }}
        />
      </Modal.Body>
    </Modal>
  );
};

export default AuroraBilledCostModal;
